import { useCallback } from "react";
import { useToken } from "@bn/api";
import { USE_INTERNAL_AUTH } from "@helpers";

import { useMandatorLinks } from "./useMandatorLinks";

export const useLogout = () => {
  const { logout: tokenLogout } = useToken({ enabled: false });
  const { logoutRedirectUrl } = useMandatorLinks();
  const logout = useCallback(() => {
    tokenLogout();

    const externalRedirectUrl = USE_INTERNAL_AUTH
      ? undefined
      : logoutRedirectUrl;
    window.location.href =
      externalRedirectUrl ?? import.meta.env.VITE_APP_ROOT_URL!;
  }, [tokenLogout, logoutRedirectUrl]);

  return {
    logout,
  };
};
